import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Box,
  Grid,
  Divider,
  Paper,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import TiptapEditor from "../../../Base/views/TiptapEditor";

const AgreementGeneral = ({
  activeStep,
  setActiveStep,
  data,
  setData,
  templateContent,
  setTemplateContent
}) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
      },
    })
  );

  const classes = useStyles();
  const [mentionUsers, setMentionUsers] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (data?.custom_fields) {
      let arr = [];
      data.custom_fields.forEach((temp) =>
        arr.push({ ...temp, id: temp?.name, display: temp?.label })
      );
      setMentionUsers(arr);
    }
  }, [data]);

  const validate = () => {
    let temp = {};
    if (!templateContent || templateContent === "<p><br></p>") {
      temp.description = "Agreement content is required";
    }
    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  const onSubmit = () => {
    if (validate()) {
      // Serialize the custom fields list inside an HTML comment at the end of the content
      const fieldsComment = `\n<!--FIELDS_JSON:${JSON.stringify(data.custom_fields)}-->`;
      const cleanContent = templateContent.replace(/<!--FIELDS_JSON:(.*)-->/, "");
      const finalContent = cleanContent.trim() + fieldsComment;

      setData(prev => ({
        ...prev,
        template_content: finalContent
      }));
      setTemplateContent(finalContent);
      setActiveStep(activeStep + 1);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12} padding={1.5}>
        <Typography sx={{ mb: 1, textAlign: "center", fontWeight: 600 }} variant="h6">
          Agreement Customization
        </Typography>
        <Paper className={`${classes?.Paper || ""} agreement-editor-container`}>
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              p: 2,
              minHeight: "300px",
            }}
          >
            <TiptapEditor
              value={templateContent.replace(/<!--FIELDS_JSON:(.*)-->/, "")}
              setValue={setTemplateContent}
              mentionUsers={mentionUsers}
              mention={true}
            />
            {errors?.description && (
              <Typography sx={{ color: "red", pt: 1 }}>
                {errors?.description}
              </Typography>
            )}
          </Grid>
        </Paper>
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            padding: "0px 10px",
          }}
        >
          <Button
            variant="contained"
            className="mpl-primary-btn"
            onClick={() => setActiveStep(activeStep - 1)}
          >
            Back
          </Button>
          <Button
            variant="contained"
            className="mpl-primary-btn"
            onClick={onSubmit}
          >
            Next
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AgreementGeneral;
